module.exports = [
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-16-d87d0e94a6.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-1-58e65020cf.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-2-20aab6aae1.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-3-6a971fa845.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-5-681231bff6.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-6-f1e85089bc.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-7-cb99c67735.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-8-f606d1f1fb.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-9-b7f32f6d4c.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-10-6554974d8c.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-11-ae23911d1c.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-12-7ca32624dd.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-13-d256301361.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-14-c22c7f4699.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-15-3c7ae5c715.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-17-16d1eb2ca7.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-18-68019976a5.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/sailing/1-8f5c0cbd55.jpg",
		"text": "Sailing @ Puget Sound, Seattle",
		"date": "Sep 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/10-46d58f3831.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/7-3c196de0c7.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/3-4a81886f61.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/4-96cbb86095.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/6-35ae386149.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/8-527aaa5b60.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/9-54b6ad3338.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/2-1b4c4eb724.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/1-a04bc475d2.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/21-af6bb9539a.jpg",
		"text": "Startupland Starbucks Buenos Aires",
		"date": "Jan 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/19-e85ad7d5f3.jpg",
		"text": "First company meeting @ Buenos Aires",
		"date": "Dec 2013"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/20-7e512b9995.jpg",
		"text": "Nodejs workshop by Jose and Matias",
		"date": "Oct 2013"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/1-6c757a6781.jpg",
		"text": "Mark at work @ Bellevue HQ",
		"date": "Feb 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/2-fefa0976a7.jpg",
		"text": "Authsado @ Gonto's house",
		"date": "March 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/3-a2ed06c5b6.jpg",
		"text": "Authsado 2 @ CTO's house",
		"date": "Feb 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/4-7f38b853d9.jpg",
		"text": "Rock'n Roll",
		"date": "Dec 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/5-bd6b6f87f9.jpg",
		"text": "Team lunch @ Burger Joint Palermo, BA",
		"date": "April 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/6-94584b33cf.jpg",
		"text": "The Gang",
		"date": "April 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/7-9175b1d4ce.jpg",
		"text": "Gonto & Woloski @ Devoxx Belgium",
		"date": "Nov 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/8-20bc3f5801.jpg",
		"text": "Team Dinner @ San Francisco",
		"date": "Jan 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/9-89b868ea90.jpg",
		"text": "DotJS Paris - Drone draw",
		"date": "Nov 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/10-3e8cbbceb7.jpg",
		"text": "JsConf.ar 2014",
		"date": "Dec 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/11-b94f32d435.jpg",
		"text": "Gonto Cheering @ Devoxx booth",
		"date": "Nov 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/12-9bf2fc94e4.jpg",
		"text": "GP leading @ Offsite 2014 Cordoba, Arg",
		"date": "Oct 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/13-e5524a8112.jpg",
		"text": "Auth0 Team hiking @ Offsite 2014 Cordoba, Arg",
		"date": "Oct 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/14-25fdd5f8d2.jpg",
		"text": "Booth ready @ OSCON 2014",
		"date": "July 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/15-064d2b21e0.jpg",
		"text": "Team dinner @ Offsite 2014 Cordoba, Arg",
		"date": "Oct 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/16-f28f713873.jpg",
		"text": "Photoshoot @ Palermo",
		"date": "Oct 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/17-19ab362d31.jpg",
		"text": "Exhausted after building the booth until 10PM.",
		"date": "Nov 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/18-890d8b6acf.jpg",
		"text": "Think tank @ Offsite 2014 Cordoba, Arg",
		"date": "Oct 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/sf/1-8bf9402919.jpg",
		"text": "HACKATON SF",
		"date": "Feb 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/sf/2-ca5c5f4138.jpg",
		"text": "Gonto being Gonto @ HACKATON SF",
		"date": "Feb 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/sf/6-317763a60c.jpg",
		"text": "Team HACKATON SF",
		"date": "Feb 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/sf/7-0bdacb1c0e.jpg",
		"text": "Drone trophy by @rauchg",
		"date": "Feb 2015"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/jobs/culture.json
// module id = 1121
// module chunks = 0